import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getThumbnail } from '@src/common/utils';
import { formatImage } from '@src/common/formatImage';
import styles from './index.css';

const Content = (props) => {

    const { content } = props;
    const [ isEnd, setIsEnd ] = useState(false);
    // UI列表
    const [ data, setData ] = useState([]);
    // 数据源列表
    const [ source, setSource ] = useState([]);

    useEffect(() => {
        // 初始渲染20条数据
        setData(content.slice(0, 20));
        // 初始渲染20条数据
        setData(content.slice(0, 20));
    }, []);
    const handleMoreData = () => {
        console.log('加载更多数据');
    };

return (
        <div>
            {
                data.map((item, index) => {
                    return (
                        <div className={styles.newsItem} key={index}>
                            <a href={item.url} target="_blank" rel="noreferrer">
                                <div className={styles.imgWp}><img src={formatImage(getThumbnail(item), 144 * 2, 80 * 2)} alt="" /></div>
                                <div className={styles.textPart}>
                                    <div className={styles.title}>{item.title}</div>
                                    <span className={styles.date}>{item.newsTime}</span>
                                </div>
                            </a>
                        </div>
                    );
                })
            }
            <div onClick={handleMoreData}>
                {isEnd ? '已显示全部' : '点击查看更多' }
            </div>
        </div>
    );
};

Content.propTypes = {
    content: PropTypes.array
};

export default errorBoundary(Content);
